import { SvgStyled } from '../../components/Global/Atomics/SvgStyled';

const NavigationPin_md = (props) => {
    const width = props.width ? props.width + 'px' : '24px';
    const height = props.height ? props.height + 'px' : '24px';

    return (
        <SvgStyled
            xmlns="http://www.w3.org/2000/svg"
            version="1.1"
            className={props.cssClasses ? `icon ${props.cssClasses}` : 'icon'}
            viewBox="0 0 24 24"
            fill={props.fill ? props.fill : 'none'}
            customColor={props.customColor}
            width={width}
            height={height}>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M12 4C8.34405 4 5.5 6.75015 5.5 10C5.5 11.6055 6.18334 13.0736 7.31854 14.1615L7.36845 14.2093L11.9223 19.9736C11.9232 19.9746 11.9289 19.9813 11.9434 19.9881C11.9578 19.9949 11.9773 20 12 20C12.0227 20 12.0422 19.9949 12.0566 19.9881C12.071 19.9813 12.0768 19.9746 12.0777 19.9736L16.6315 14.2094L16.6814 14.1615C17.8166 13.0736 18.5 11.6055 18.5 10C18.5 6.75015 15.656 4 12 4ZM3.5 10C3.5 5.51786 7.37168 2 12 2C16.6283 2 20.5 5.51786 20.5 10C20.5 12.1684 19.5834 14.1257 18.1165 15.5559L13.647 21.2134C13.2458 21.7212 12.6304 22 12 22C11.3696 22 10.7542 21.7212 10.353 21.2134L5.88343 15.5559C4.41653 14.1256 3.5 12.1684 3.5 10ZM12 7C10.3431 7 9 8.34315 9 10C9 11.6569 10.3431 13 12 13C13.6569 13 15 11.6569 15 10C15 8.34315 13.6569 7 12 7ZM7 10C7 7.23858 9.23858 5 12 5C14.7614 5 17 7.23858 17 10C17 12.7614 14.7614 15 12 15C9.23858 15 7 12.7614 7 10Z"
            />
        </SvgStyled>
    );
};

export default NavigationPin_md;
